// Libraries
import { useTranslation } from 'react-i18next';

// MUI
import Grid from '@mui/material/Grid';

// Core
import auth from '../../core/authorization';
import { ResourceTextApplication } from '../../core/resources';

// Common
import { AAddButton } from '../../common/buttons';

// Interfaces
// Store
import { useAppSelector } from '../../store/hooks';

// API
// Feature - Feedback
import { SelectorConstants } from './constants/SelectorConstants';

interface INewFeedbackButtonProps {
    loading: boolean;
    handleFeedbackDialogOpening: (value: boolean) => void;
}

export default function NewFeedbackButton({
    loading,
    handleFeedbackDialogOpening,
}: INewFeedbackButtonProps) {
    const userData = useAppSelector((state) => state.userData.data);

    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaCommunication']);

    const isNewFeedbackBtnHidden = () => {
        if (userData.IsSnellmanUser && (userData.IsTrafficContractor || userData.IsDriver)) {
            return true;
        } else if (userData.IsTrafficContractor || userData.IsDriver) {
            return true;
        }
        return false;
    };

    const getNewFeedbackBtn = () => {
        if (isNewFeedbackBtnHidden()) return <></>;

        return (
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} style={{ textAlign: 'right' }}>
                <AAddButton
                    data-robot-id={SelectorConstants.CreateFeedbackBtn}
                    onClick={() => handleFeedbackDialogOpening(true)}
                    type='action'
                    disabled={!auth.canCreateFeedback || loading}
                >
                    {t('AnelmaCommunication:1086')}
                </AAddButton>
            </Grid>
        );
    };

    return getNewFeedbackBtn();
}
